import { render } from "./SearchIndexDetails.vue?vue&type=template&id=40d6ce6a"
import script from "./SearchIndexDetails.vue?vue&type=script&lang=js"
export * from "./SearchIndexDetails.vue?vue&type=script&lang=js"

import "./SearchIndexDetails.vue?vue&type=style&index=0&id=40d6ce6a&lang=css"
script.render = render

export default script